import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  computed: {
    evaluationText: {
      get() {
        return this.$store.state.profile.evaluation.evaluationText;
      },
      set(value) {
        this.$store.commit('profile/evaluation/setEvaluationText', value);
      }
    },
    ...mapGetters({
      evaluationHelp: 'profile/evaluation/evaluationHelp',
      evaluationAnswerId: 'profile/evaluation/evaluationAnswerId',
      evaluationServiceType: 'profile/evaluation/evaluationServiceType',
      evaluationServiceEntityId: 'profile/evaluation/evaluationServiceEntityId'
    })
  },
  methods: {
    ...mapMutations({
      setDialog: 'profile/dashboard/setDialog',
      setEvaluationHelp: 'profile/evaluation/setEvaluationHelp',
      setEvaluationAnswerId: 'profile/evaluation/setEvaluationAnswerId',
      setEvaluationText: 'profile/evaluation/setEvaluationText',
      setEvaluationServiceType: 'profile/evaluation/setEvaluationServiceType',
      setEvaluationServiceEntityId: 'profile/evaluation/setEvaluationServiceEntityId'
    }),
    ...mapActions({
      loadData: 'profile/service/loadData',
      resetEvaluation: 'profile/evaluation/resetEvaluation'
    }),
    openEvaluation(help, serviceType, serviceEntityId, answerId) {
      this.setEvaluationHelp(help);
      this.setDialog('evaluation');
      this.setEvaluationAnswerId(answerId);
      this.setEvaluationServiceType(serviceType);
      this.setEvaluationServiceEntityId(serviceEntityId);
    },
    async sendEvaluation(isSkip) {
      let evaluationUrl = '';
      let evaluationData = {};

      if (this.evaluationServiceType === 'question') {
        if (!this.evaluationAnswerId) {
          this.handleError({ error: new Error('Missing evaluationAnswerId'), code: '0x0000002E' });
          return;
        }
        evaluationUrl = '/v3/fe/answers/rate/' + this.evaluationAnswerId;
        evaluationData = {
          helped: Boolean(this.evaluationHelp),
          comment: !isSkip ? (this.evaluationText ?? '') : ''
        };
      }

      if (this.evaluationServiceType === 'appointment') {
        const serviceData = this.$store.state.profile.service?.data || {};
        const hashWithFallback =
          serviceData.hashId ?? serviceData.hash ?? this.evaluationServiceEntityId ?? '';
        const hash = String(hashWithFallback ?? '');

        if (!hash) {
          this.handleError({ error: new Error('Missing evaluation hash'), code: '0x00000087' });
          return;
        }

        evaluationUrl = '/v3/evaluation/appointment';
        evaluationData = {
          hash,
          evaluation: this.evaluationHelp === 2 ? 2 : this.evaluationHelp ? 1 : 0,
          confirmed: true,
          message: !isSkip ? (this.evaluationText ?? '') : ''
        };
      }

      await this.$http
        .post(evaluationUrl, evaluationData)
        .then(async () => {
          if (this.isMobileApp) {
            return;
          }

          await this.loadData({
            serviceType: this.evaluationServiceType,
            serviceEntityId: this.evaluationServiceEntityId
          });
        })
        .catch(err => {
          this.handleError({ error: err, code: '0x00000086' });
          throw err;
        });
    }
  }
};
